import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';
import MenuItem from 'flow/components/ui-components/MenuItem';

interface Props {
    onClick: () => void;
}

const MenuItemShowJoinInfo = ({ onClick }: Props) => {
    const { i18next } = useAppContext();

    return (
        <MenuItem
            onClick={onClick}
            className="!bg-gray-800 !text-white hover:!bg-gray-700"
        >
            <Icon iconKey="infoOutlinedIcon" className="me-1.5" />
            <div>{i18next.t('videoconference.controlpanel.joining_info')}</div>
        </MenuItem>
    );
};

export default MenuItemShowJoinInfo;
